import { render, staticRenderFns } from "./Alterar.vue?vue&type=template&id=5f0a91d0"
import script from "./Alterar.vue?vue&type=script&lang=js"
export * from "./Alterar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports